module.exports = __webpack_public_path__ + "img/2.33f5c22f.jpg";